export default __webpack_public_path__ + "static/media/woof1@3x.de6a522f.png";